function wrap(toWrap, wrapper) {
  wrapper = wrapper || document.createElement('div')
  toWrap.parentNode.insertBefore(wrapper, toWrap)
  wrapper.appendChild(toWrap)

  return wrapper
}

// Set frame aspect ratio of all fixed-dimension iframes / images
function setFrameAspect(frame) {
  const frameWidth = frame.getAttribute('width')
  const frameHeight = frame.getAttribute('height')

  if (!/^\d+$/.test(frameWidth) || !/^\d+$/.test(frameHeight)) {
    return
  }

  if (frameWidth && frameHeight) {
    // wrap the iframe in an aspect-ratio div
    const aspectRatioDiv = wrap(frame)
    aspectRatioDiv.className = 'aspect-ratio-div'
    aspectRatioDiv.style.paddingTop = `${parseInt(frameHeight) / parseInt(frameWidth) * 100}%`
    frame.style.width = '100%'
    frame.style.height = '100%'
  }
}

function handleContentMedia() {
  const iframes = document.querySelectorAll('#body-content iframe')
  for (const iframe of iframes) {
    setFrameAspect(iframe)
  }

  const images = document.querySelectorAll('#body-content figure img')
  for (const image of images) {
    setFrameAspect(image)
  }
}

function init() {
  const jQuery = window.jQuery
  jQuery(document).on('content:load', handleContentMedia)
}

export default init